import { transparent } from "material-ui/styles/colors"

const THEME_PRIMARY = "#3C9AFF"

export const colors = {
  // Marketplaces colors
  autouncle: "#1298CC",
  mobile: "#FF5E24",
  autoscout24: "#F6F142",
  "automobile.it": "#BD4B00",
  subito: "#F9423A",

  // Black
  black: "#000",
  // White
  white: "#FFF",
  // Transparent
  transparent: transparent,

  // Used for numbered cards for Business Booster Landing Page only
  gradient_blue: "#D1F1FA",
  gradient_red: "#FAD1D1",
  gradient_green: "#D1FAD1",

  // Cool
  gray_100: "#F5F8FB",
  gray_200: "#D4E3F5",
  gray_300: "#B5D0EF",
  gray_400: "#95AFCD",
  gray_500: "#7890AB",
  gray_600: "#5C7189",
  gray_700: "#425367",
  gray_800: "#2A3745",
  gray_900: "#0A0D10",

  // Blue dark
  blue_100: "#E6F2FF",
  blue_200: "#ADD4FF",
  blue_300: "#74B7FF",
  blue_400: THEME_PRIMARY,
  blue_500: "#036FE3",
  blue_600: "#0055B0",
  blue_700: "#003C7D",
  blue_800: "#00244A",
  blue_900: "#000C19",
  blue_900: "#02234C",

  // Blue light
  variant_50: "#ECFBFF",
  variant_100: "#ECFBFF",
  variant_200: "#C0F1FF",
  variant_300: "#95E8FF",
  variant_400: "#6ADFFF",
  variant_500: "#3FD5FF",
  variant_600: "#1BADD5",
  variant_700: "#0180A2",
  variant_800: "#00576F",
  variant_900: "#002833",

  // Green Successfull
  green_100: "#F5FFFA",
  green_200: "#D8FFEC",
  green_300: "#BBFFDE",
  green_400: "#9DFDCF",
  green_500: "#77D4A7",
  green_600: "#52A37C",
  green_700: "#3A835F",
  green_800: "#235A3F",
  green_900: "#0E251A",

  // Orange Attention
  orange_100: "#FFF3E9",
  orange_200: "#FFCFA8",
  orange_300: "#FFAB66",
  orange_400: "#F28023",
  orange_500: "#C7620F",
  orange_600: "#9E4801",
  orange_700: "#763500",
  orange_800: "#4D2300",
  orange_900: "#190B00",

  // Red Error
  red_100: "#FFECEC",
  red_200: "#FFB3B3",
  red_300: "#FF7B7B",
  red_400: "#FA5050",
  red_500: "#DE2B2B",
  red_600: "#BA1717",
  red_700: "#910808",
  red_800: "#680000",
  red_900: "#190000",

  info: THEME_PRIMARY,
  error: "#F01010",
  success: "#66BB6A",
  warning: "#FFA726",

  // Price Rating
  super: "#026214", // rgb(2, 98, 20)
  good: "#68A52E", // rgb(104, 165, 46)
  fair: "#069B66", // rgb(6, 155, 102)
  overpriced: "#E39806", // rgb(227, 152, 6)
  expensive: "#AD1D19", // rgb(173, 29, 25)
}

// Make sure to update PaddingType when making changes to spacing array
export const spacing = [
  "0px", // 0
  "4px", // 1
  "8px", // 2
  "12px", // 3
  "16px", // 4
  "24px", // 5
  "32px", // 6
  "40px", // 7
  "48px", // 8
  "64px", // 9
  "80px", // 10
]

export type PaddingType = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10

export const width = {
  "1/10": "10%",
  "1/5": "20%",
  "1/4": "25%",
  "3/10": "30%",
  "1/3": "33%",
  "2/5": "40%",
  "1/2": "50%",
  "3/5": "60%",
  "2/3": "66%",
  "7/10": "70%",
  "3/4": "75%",
  "4/5": "80%",
  "9/10": "90%",
  full: "100%",
  inherit: "inherit",
  auto: "auto",
  maxContent: "max-content",
  content: "950px",
}

export const radius = {
  full: "30px",
  large: "16px",
  medium: "8px",
  small: "4px",
  sharp: "0px",
}

export const justify = {
  start: "flex-start",
  end: "flex-end",
  center: "center",
  between: "space-between",
  around: "space-around",
  evenly: "space-evenly",
}

export const align = {
  start: "flex-start",
  end: "flex-end",
  center: "center",
  baseline: "baseline",
  stretch: "stretch",
}

export const content = {
  start: "flex-start",
  end: "flex-end",
  center: "center",
  between: "space-between",
  around: "space-around",
  evenly: "space-evenly",
}

const shadows = {
  shadow_base:
    "0px 1px 2px rgba(0, 0, 0, 0.06), 0px 1px 3px rgba(0, 0, 0, 0.1);",
  shadow_50: "0px 4px 24px rgba(2, 35, 76, 0.08);",
  shadow_100: "0px 8px 40px rgba(2, 35, 76, 0.16);",
}

const fonts = {
  fontDisplay: "Manrope",
  fontBody: "Inter",
  fontSerif: "Lora",
}

export const theme = {
  ...colors,
  ...shadows,
  ...fonts,
  spacing,
  width,
  align,
  justify,
  content,
  radius,
}
